// CI redeploy trigger: file_types/task_types privileges (branch uk/file-task-type-privileges)
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import 'react-quill/dist/quill.snow.css';
import App from './App';
import PatientApp from './PatientApp';
import IsraelApp from './IsraelApp';
import { AuthProvider } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';
import { resolveApp } from './config/appMode';
import theme from './theme';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const appTarget = resolveApp();

function renderApp() {
  switch (appTarget) {
    case 'patient':
      // UK patient app: no auth/tenant providers, only public flows.
      return <PatientApp />;
    case 'israel':
      // Israel patient app: no auth/tenant providers, only public flows.
      return <IsraelApp />;
    default:
      return (
        <AuthProvider>
          <TenantProvider>
            <App />
          </TenantProvider>
        </AuthProvider>
      );
  }
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          {renderApp()}
          <Toaster position="top-right" />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
